<template>
  <v-alert
    type="warning"
    prominent
    border="left">
    ブラウザに一時保存された{{ typeName }}データがあります。
    <div class="pt-3 pl-5 pb-3">
      <div class="d-flex">
        <span>案件名:</span>
        <h4>{{ dataTitle }}</h4>
      </div>
      <div class="d-flex">
        <span>保存時間:</span>
        <h4>{{ dataDate }}</h4>
      </div>
    </div>
    <v-divider />
    <v-spacer />
    <v-btn
      outlined
      style="margin: 8px 0 0 300px"
      @click.prevent="onContinueSessionClicked">
      続きから入力
    </v-btn>
  </v-alert>
</template>

<script>
import {
  getLastUnsavedSessionDate,
  getStepObjectId,
  getStepSession,
} from '../logic/session'

export default {
  name: 'UnsavedSessionNotify',
  props: {
    sessionName: {
      type: String,
      require: true,
      default: '',
    },
    routeNameNew: {
      type: String,
      require: true,
      default: '',
    },
    routeNameContinue: {
      type: String,
      require: true,
      default: '',
    },
  },
  computed: {
    dataTitle() {
      const session = getStepSession(
        this.sessionName,
        this.sessionName === 'written-survey' || this.sessionName === 'report'
          ? 2
          : 1,
      )
      return session ? session.title : ''
    },
    dataDate() {
      return getLastUnsavedSessionDate(this.sessionName)
    },
    typeName() {
      switch (this.sessionName) {
        case 'confirmation':
          return '整合性確認表'
        case 'written-survey':
          return '書面調査'
        case 'field-survey':
          return '現地調査'
        case 'detail':
          return '詳細表'
        case 'report':
          return '報告書'
        default:
          return ''
      }
    },
  },
  methods: {
    // ダイアログ 復元するボタン
    onContinueSessionClicked() {
      this.$emit('continue')
      if (this.routeNameContinue) {
        const id = getStepObjectId(this.sessionName)
        this.$router.push({ name: this.routeNameContinue, params: { id } })
      }
    },
  },
}
</script>

<style scoped>

</style>
